import React from 'react';
import './HowWeBuild.css';
import FrameIcon from './Frame.svg';

const steps = [
  {
    title: 'Empathize First',
    desc: "We start by understanding real user pain - whether it's a judge, doctor, or compliance officer",
  },
  {
    title: 'Dream Big, Design Smart',
    desc: 'Ideate copilots, LLM flows, and dashboards that feel intelligent - not intrusive',
  },
  {
    title: 'Build Fast, Safely',
    desc: 'Rapid prototypes with security, ethics, and performance baked in',
  },
  {
    title: 'Feedback as Fuel',
    desc: 'User pilots, partner loops, internal reviews - everyone contributes',
    // link: true,
  },
  {
    title: 'Deploy with Confidence',
    desc: 'Secure, scalable, user-loved features go live - with your name on them',
  },
];

const isMobile = window.innerWidth < 768;

const HowWeBuild = () => (
  <section className="hwb-section">
    <div className="wave1-bg">
      <img src="/images/wavedownward.svg" alt="" />
    </div>
    <div className="hwb-header-row">
      <div className="hwb-header-col">
        <div className="hwb-badge">HOW WE BUILD</div>
        <div className="hwb-title-row">
          {isMobile && (<><h2 className="hwb-title">From ideation to impact</h2>
            <em className="hwb-desc">We follow a modular, agile, and people-driven approach to shipping great AI:</em>
          </>)}
          {!isMobile && (<>
            <em className="hwb-desc">We follow a modular, agile, and people-driven approach to shipping great AI:</em>
            <h2 className="hwb-title">From ideation to impact</h2></>)}
        </div>
      </div>
    </div>
    <div className="hwb-steps">
      {steps.map((step, i) => (<>
        {isMobile && <><div className="hwb-step-row" key={i}>
          <div className="hwb-step-num">{String(i + 1).padStart(2, '0')}</div>
          <div className="hwb-step-title">{step.title}
            <div className="hwb-step-desc">
              {step.link ? (
                <a href="#" className="hwb-step-link">{step.desc}</a>
              ) : (
                step.desc
              )}
            </div>
          </div>
        </div></>}
        {!isMobile &&
          <div className="hwb-step-row" key={i}>
            <div className="hwb-step-num">{String(i + 1).padStart(2, '0')}</div>
            <div className="hwb-step-title">{step.title}</div>
            <div className="hwb-step-desc">
              {step.link ? (
                <a href="#" className="hwb-step-link">{step.desc}</a>
              ) : (
                step.desc
              )}
            </div>
          </div>}</>
      ))}
    </div>
    <div className="hwb-note">
      <span className="hwb-note-icon" role="img" aria-label="idea">
        <img src={FrameIcon} alt="Frame Icon" width={22} height={22} />
      </span>
      <span className="hwb-note-text">From clinical workflows to plant operations and legal decisions, Cognitva moves AI from intent to impact.</span>
    </div>
  </section>
);

export default HowWeBuild; 